// extracted by mini-css-extract-plugin
module.exports = {"root":"-DeRq","originalPrice":"_13blh","promoPrice":"tf4fk"};